import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const ImageCount = () => {
  const {themeName,getThemeColor} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M11.0977 3.15257C11.6232 3.33725 12 3.83791 12 4.42656V10.4266C12 11.8349 10.8583 12.9766 9.45 12.9766H3.45C2.86134 12.9766 2.36069 12.5998 2.17601 12.0743L3.43438 12.0763L9.45 12.0766C10.3613 12.0766 11.1 11.3378 11.1 10.4266V4.42656L11.0976 4.39597L11.0977 3.15257ZM9.14809 0.976562C9.89367 0.976562 10.4981 1.58098 10.4981 2.32656V10.1247C10.4981 10.8702 9.89367 11.4747 9.14809 11.4747H1.35C0.604416 11.4747 0 10.8702 0 10.1247V2.32656C0 1.58098 0.604416 0.976562 1.35 0.976562H9.14809Z"
        fill={themeName != "light"?"#C1C1C1":getThemeColor("study-details-icon")}
      />
    </svg>
  );
};

export default ImageCount;
